export class PaginationEntity {
  private page: number;
  private total: number;
  private limit: number;

  constructor(page?: number, total?: number, limit?: number) {
    this.page = page ?? 1;
    this.total = total ?? 1;
    this.limit = limit ?? 1;
  }


  public getPage(): number {
    return this.page;
  }

  public setPage(page: number): void {
    this.page = page;
  }

  public getTotal(): number {
    return this.total;
  }

  public setTotal(total: number): void {
    this.total = total;
  }

  public getLimit(): number {
    return this.limit;
  }

  public setLimit(limit: number): void {
    this.limit = limit;
  }
}
